import { render } from "./ResidentInterview.vue?vue&type=template&id=2cfb7ca4"
import script from "./ResidentInterview.vue?vue&type=script&lang=js"
export * from "./ResidentInterview.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\carl.DC_ADVOCATIA\\Documents\\GitHub\\benefit-screening-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__